import { useMemo } from "react";
import { useOrders } from "@/lib/OrdersContext";
import { PageHeader, DataTable } from "@/components/PageHeader";
import { eur } from "@/lib/workshop";

const HEAD = ["Cliente", "Teléfono", "Email", "Vehículos", "Órdenes", "Facturado"];

export default function ClientesPage() {
  const { searchAll: filtered } = useOrders();
  const clients = useMemo(() => {
    const m = new Map();
    filtered.forEach((o) => {
      const key = o.clienteId || o.cliente;
      const c = m.get(key) || { key, nombre: o.cliente, telefono: o.telefono, email: o.email, vehiculos: new Set(), ordenes: 0, total: 0 };
      c.vehiculos.add(o.matricula); c.ordenes += 1; c.total += o.importe;
      m.set(key, c);
    });
    return [...m.values()];
  }, [filtered]);

  const rows = clients.map((c) => (
    <tr key={c.key} data-testid={`client-row-${c.key}`} className="border-b border-white/5 transition-colors hover:bg-white/[0.02]">
      <td className="px-5 py-3 font-semibold">{c.nombre || "Sin nombre"}</td>
      <td className="px-5 py-3 text-zinc-400">{c.telefono || "—"}</td>
      <td className="px-5 py-3 text-zinc-400">{c.email || "—"}</td>
      <td className="px-5 py-3">{c.vehiculos.size}</td>
      <td className="px-5 py-3">{c.ordenes}</td>
      <td className="px-5 py-3 font-semibold text-[var(--gold)]">{eur(c.total)}</td>
    </tr>
  ));
  return (
    <>
      <PageHeader title="Clientes" subtitle={`${clients.length} clientes con órdenes registradas`} />
      <DataTable testid="clients-table" head={HEAD} rows={rows} empty="Aún no hay clientes" />
    </>
  );
}
